const comments = [
  {
    name: '光影追梦人',
    text: '用了桃子影院快两年了，片源更新速度快得惊人。上周刚上映的片子这周就有高清版了，画质真的没话说，4K看着太爽了，关键还完全免费，已经推荐给身边所有朋友了！',
    rating: 5,
    date: '2026-07-28',
  },
  {
    name: '周末电影控',
    text: '华语电影专区做得特别用心，港片经典修复版画质很好，连小时候看的那些老片子都能找到。播放确实秒开不缓冲，比很多收费软件还流畅，真心推荐给爱看电影的朋友。',
    rating: 5,
    date: '2026-07-25',
  },
  {
    name: '技术宅小陈',
    text: '作为程序员，对加载速度比较挑剔。桃子影院的CDN优化做得确实到位，4K蓝光片源预加载几乎感觉不到延迟，自适应码率切换也很智能，移动网络下自动降画质保证流畅度，体验很好。',
    rating: 5,
    date: '2026-07-22',
  },
  {
    name: '追剧不眠人',
    text: '之前找一部冷门文艺片找了好久，没想到在桃子影院搜到了，而且还是蓝光修复版。专题合集分类也很细致，按类型、年代、评分都能筛，找片效率高了很多。希望一直免费下去！',
    rating: 4,
    date: '2026-07-20',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">用户评价</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">来自真实影迷的使用反馈，看看大家怎么说</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/40"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/15 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-400 font-bold text-sm">{item.name[0]}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-50">{item.name}</div>
                  <div className="text-[11px] text-foreground-500">{item.date}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, j) => (
                    <i
                      key={j}
                      className={`ri-star-fill text-xs ${
                        j < item.rating ? 'text-primary-400' : 'text-foreground-600'
                      }`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-200 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}